import React, { Component } from "react";
import { connect } from "react-redux";

import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { v4 as uuidv4 } from "uuid";
import { 
    getCmsContent_action, 
    insertUpdateCmsMenu_action, 
    deleteCmsMenu_action, 
    insertUpdateCmsSubheader_action, 
    insertUpdateCMSGovtLogo_action, 
    updateCmsGovtLogoStatus_action 
} from "../../actions/cms_action/cmsAction";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../utils/withRouter";
import { BASE_URL, toastError, toastSuccess } from "../../utils/constants";
// IMPORT TABS ALONGSIDE TAB
import { Tab, Tabs } from "react-bootstrap";

class cmsHeaderMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuList: [],
            isLoading: false,
            cmsMenuData: [],
            cmsFooterData: [],
            cmsSubheaderData: [],
            editingRowId: null,
            govtLogoList: [],
            downloadUrl: ''
        };
    }

    componentDidMount() {
        this.getCmsContent();
        const sortUrl = BASE_URL.split("/api");
        this.setState({ downloadUrl: sortUrl[0] });
    }

    handleEdit = (tableId) => {
        this.setState({ editingRowId: tableId });
    };

    handleChange = (e, key, value) => {
        const { cmsSubheaderData, editingRowId } = this.state;
        const updatedData = cmsSubheaderData.map((row) => {
            if ((row.tableId || row.SubheaderID) === editingRowId) {
                return { ...row, [key]: value !== undefined ? value : e.target.value };
            }
            return row;
        });
        this.setState({ cmsSubheaderData: updatedData });
    };

    handleAddRow = (tableId) => {
        const { cmsSubheaderData } = this.state;
        const index = cmsSubheaderData.findIndex(row => (row.tableId || row.SubheaderID) === tableId);

        const newRow = {
            tableId: Date.now(),
            SubheaderID: null,
            SubheaderName: "",
            ViewType: "",
            SocialType: "",
            Link: "",
            isActive: false,
            isPublish: false
        };

        const updatedData = [...cmsSubheaderData.slice(0, index + 1), newRow, ...cmsSubheaderData.slice(index + 1)];
        this.setState({ cmsSubheaderData: updatedData, editingRowId: newRow.tableId });
    };

    async getCmsContent() {
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(1, 'home');

            if (data.error !== 1) {
                const flatList = data?.data?.[1] || [];
                const cmsSubheaderData = data?.data[4] !== "" ? data?.data[4] : []

                const menuMap = {};
                flatList.forEach(item => {
                    item.id = uuidv4();
                    item.children = [];
                    item.showSave = false;
                    menuMap[item.MenuID] = item;
                });

                const rootMenus = [];
                flatList.forEach(item => {
                    if (item.ParentID) {
                        if (menuMap[item.ParentID]) {
                            menuMap[item.ParentID].children.push(item);
                        }
                    } else {
                        rootMenus.push(item);
                    }
                });

                this.setState({
                    isLoading: false,
                    cmsMenuData: data?.data?.[1],
                    cmsFooterData: data?.data?.[2][0],
                    cmsSubheaderData: cmsSubheaderData,
                    menuList: rootMenus,
                    govtLogoList: data?.data?.[6] ? data?.data?.[6] : []
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }


    saveRowLocally = (id) => {
        const updateMenus = (menus) =>
            menus.map(menu => {
                if (menu.id === id) {
                    const title = menu.Title?.trim();
                    const url = menu.URL?.trim();

                    if (!title || !url) {
                        toastError('Both Title and URL are required.');
                        return menu;
                    }

                    return { ...menu, showSave: false };
                } else if (menu.children) {
                    return {
                        ...menu,
                        children: updateMenus(menu.children)
                    };
                }
                return menu;
            });

        this.setState(prev => ({
            menuList: updateMenus(prev.menuList)
        }), () => {
            this.submitMenu()
        });
    };

    handleRemove = (menu, parent = null) => {
        if (menu.MenuID) {
            this.setState((prevState) => {
                const updatedList = prevState.menuList.map((item) => {
                    if (item.id === menu.id) {
                        return { ...item, isActive: false };
                    } else if (item.children) {
                        return {
                            ...item,
                            children: item.children.map((child) =>
                                child.id === menu.id ? { ...child, isActive: false } : child
                            ),
                        };
                    }
                    return item;
                });
                return { menuList: updatedList };
            });
        } else {
            this.setState((prevState) => {
                let updatedList = [...prevState.menuList];
                if (parent) {
                    updatedList = updatedList.map((item) => {
                        if (item.id === parent.id) {
                            return {
                                ...item,
                                children: item.children.filter((child) => child.id !== menu.id),
                            };
                        }
                        return item;
                    });
                } else {
                    updatedList = updatedList.filter((item) => item.id !== menu.id);
                }
                return { menuList: updatedList };
            });
        }
    };

    addNewMenu = (parentId = null) => {
        const createNewMenu = (sequence) => ({
            id: uuidv4(),
            MenuID: null,
            ParentID: parentId,
            Title: "",
            Url: "",
            Sequence: sequence,
            isActive: true,
            isPublish: true,
            isMenuItem: false,
            children: [],
            showSave: true
        });

        if (!parentId) {
            const maxSequence = this.state.menuList.reduce((max, item) => Math.max(max, item.Sequence || 0), 0);
            this.setState(prev => ({
                menuList: [...prev.menuList, createNewMenu(maxSequence + 1)],
            }));
            return;
        }

        const updateTree = (menus) => menus.map(menu => {
            if (menu.id === parentId) {
                const children = menu.children || [];
                const maxChildSequence = children.reduce((max, item) => Math.max(max, item.Sequence || 0), 0);
                return { ...menu, children: [...children, createNewMenu(maxChildSequence + 1)] };
            }
            if (menu.children && menu.children.length > 0) {
                return { ...menu, children: updateTree(menu.children) };
            }
            return menu;
        });

        this.setState(prev => ({ menuList: updateTree(prev.menuList) }));
    };

    handleInputChange = (id, field, value) => {
        if (field === 'Url') value = value.replace(/\s/g, '');

        const updateTree = (menus) => menus.map(menu => {
            if (menu.id === id) {
                return { ...menu, [field]: value, showSave: true };
            }
            if (menu.children && menu.children.length > 0) {
                return { ...menu, children: updateTree(menu.children) };
            }
            return menu;
        });

        this.setState(prev => ({ menuList: updateTree(prev.menuList) }));
    };

    async deleteCmsMenu(menu) {
        if (menu.MenuID) {
            try {
                this.setState({ isLoading: true });
                const isConfirm = window.confirm('Are you sure you want to remove this Menu?');
                if (isConfirm) {
                    const data = await this.props.deleteCmsMenu_action(menu.MenuID);
                    if (data.error !== 1 && data.data !== "") {
                        toastSuccess(`Menu Deleted Successfully`);
                        this.getCmsContent();
                    } else {
                        toastError(data.msg);
                    }
                }
            } catch (err) {
                console.error(err);
            } finally {
                this.setState({ isLoading: false });
            }
        } else {
            const removeNode = (menus) => menus
                .filter(item => item.id !== menu.id)
                .map(item => {
                    if (item.children && item.children.length > 0) {
                        return { ...item, children: removeNode(item.children) };
                    }
                    return item;
                });

            this.setState(prev => ({ menuList: removeNode(prev.menuList) }));
        }
    }

    onDragEnd = result => {
        const { source, destination, type } = result;
        if (!destination) return;

        if (type === "PARENT") {
            const items = Array.from(this.state.menuList);
            const [reorderedItem] = items.splice(source.index, 1);
            items.splice(destination.index, 0, reorderedItem);
            this.setState({ menuList: items });
            return;
        }

        const updateTreeForDnd = (menus) => menus.map(item => {
            if (item.id.toString() === type) {
                const children = Array.from(item.children || []);
                const [reorderedChild] = children.splice(source.index, 1);
                children.splice(destination.index, 0, reorderedChild);
                return { ...item, children };
            }
            if (item.children && item.children.length > 0) {
                return { ...item, children: updateTreeForDnd(item.children) };
            }
            return item;
        });

        this.setState(prev => ({ menuList: updateTreeForDnd(prev.menuList) }));
    };

    renderMenuRow = (menu, index, sequencePrefix = "", depth = 0) => {
        const currentSequenceStr = `${sequencePrefix}${menu.Sequence}`;
        const bgColor = depth === 0 ? "white" : depth === 1 ? "#eee" : "#f5f5f5"; 

        return (
            <Draggable key={menu.id} draggableId={menu.id.toString()} index={index}>
                {(provided) => (
                    <tr
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{ ...provided.draggableProps.style, backgroundColor: bgColor }}
                    >
                        <td style={{ width: '425px' }}>
                            <input style={{ width: '100%' }} type="text" placeholder="Title" className="form-control"
                                value={menu.Title} onChange={(e) => this.handleInputChange(menu.id, "Title", e.target.value)} />
                        </td>
                        <td style={{ width: '430px' }}>
                            <input type="text" placeholder="Url" className="form-control"
                                value={menu.Url} onChange={(e) => this.handleInputChange(menu.id, "Url", e.target.value)} />
                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            {currentSequenceStr}
                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            <div className="custom-control custom-checkbox" onClick={() => this.handleInputChange(menu.id, "isActive", !menu.isActive)}>
                                <input type="checkbox" className="custom-control-input" readOnly checked={menu.isActive} />
                                <label className="custom-control-label"></label>
                            </div>
                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            <div className="custom-control custom-checkbox" onClick={() => this.handleInputChange(menu.id, "isPublish", !menu.isPublish)}>
                                <input type="checkbox" className="custom-control-input" readOnly checked={menu.isPublish} />
                                <label className="custom-control-label"></label>
                            </div>
                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            <div className="custom-control custom-checkbox" onClick={() => this.handleInputChange(menu.id, "isMenuItem", !menu.isMenuItem)}>
                                <input type="checkbox" className="custom-control-input" readOnly checked={menu.isMenuItem} />
                                <label className="custom-control-label"></label>
                            </div>
                        </td>
                        <td className="text-right" style={{ width: '100px' }}>
                            {menu.MenuID && (
                                <i className="far fa-plus-square" style={{ marginRight: '10px', cursor: 'pointer' }} onClick={() => this.addNewMenu(menu.id)} />
                            )}
                            <i className="fas fa-trash-alt" style={{ cursor: 'pointer' }} onClick={() => this.deleteCmsMenu(menu)} />
                        </td>
                    </tr>
                )}
            </Draggable>
        );
    };

    renderDroppableChildren = (menu, sequencePrefix, depth) => {
        if (!menu.children || menu.children.length === 0) return null;

        return (
            <Droppable droppableId={menu.id.toString()} type={menu.id.toString()}>
                {(providedChild) => (
                    <tr>
                        <td className="pr-0" colSpan="7" style={{ paddingLeft: '20px', borderLeft: '3px solid #ccc' }}>
                            <table className="table mb-0">
                                <tbody ref={providedChild.innerRef} {...providedChild.droppableProps}>
                                    {menu.children.sort((a, b) => a.Sequence - b.Sequence).map((child, childIndex) => (
                                        <React.Fragment key={child.id}>
                                            {this.renderMenuRow(child, childIndex, sequencePrefix, depth + 1)}
                                            {this.renderDroppableChildren(child, `${sequencePrefix}${child.Sequence}.`, depth + 1)}
                                        </React.Fragment>
                                    ))}
                                    {providedChild.placeholder}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                )}
            </Droppable>
        );
    };

    submitSubmenu = async () => {
        const { cmsSubheaderData, editingRowId } = this.state;
        const selectedRow = cmsSubheaderData.find(row => (row.tableId || row.SubheaderID) === editingRowId);

        if (!selectedRow.SubheaderName) {
            toastError("Please Enter Name");
            return;
        }
        if (!selectedRow.ViewType) {
            toastError("Please Select View Type");
            return;
        }
        if (selectedRow.ViewType === "SM" && !selectedRow.SocialType) {
            toastError("Please Select Social Type");
            return;
        }
        if (!selectedRow.Link) {
            toastError("Please Provide Link");
            return;
        }

        try {
            this.setState({ isLoading: true });
            const data = await this.props.insertUpdateCmsSubheader_action(
                selectedRow.SubheaderID,
                selectedRow.SubheaderName,
                selectedRow.ViewType,
                selectedRow.SocialType,
                selectedRow.Link,
                selectedRow.isActive,
                selectedRow.isPublish
            );

            this.setState({ isLoading: false, editingRowId: null });

            if (data.error !== 1) {
                toastSuccess("Sub Menu Added Successfully");
                this.getCmsContent();
            } else {
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    };

    async submitMenu() {
        try {
            const { menuList } = this.state;
            this.setState({ isLoading: true });

            const flatMenuList = [];

            const flattenMenus = (menus, parentId = null) => {
                for (const item of menus) {
                    const { children, id, showSave, ...itemData } = item;

                    const hasInvalidItem = !itemData.Title?.trim() || !itemData.Url?.trim();
                    if (hasInvalidItem) {
                        throw new Error('Kindly Enter Title and Url in all Menu items.');
                    }

                    flatMenuList.push({
                        MenuID: itemData.MenuID || null,
                        ParentID: parentId, 
                        Title: itemData.Title,
                        Url: itemData.Url,
                        Sequence: itemData.Sequence,
                        isActive: itemData.isActive,
                        isPublish: itemData.isPublish,
                        isMenuItem: itemData.isMenuItem
                    });

                    if (children && children.length > 0) {
                        if (itemData.MenuID) {
                            flattenMenus(children, itemData.MenuID);
                        }
                    }
                }
            };

            try {
                flattenMenus(menuList, null);
            } catch (validationError) {
                toastError(validationError.message);
                this.setState({ isLoading: false });
                return;
            }

            const data = await this.props.insertUpdateCmsMenu_action(flatMenuList);
            this.setState({ isLoading: false });

            if (data.error !== 1) {
                toastSuccess('Menu Added Successfully');
                this.getCmsContent(); 
            } else {
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    //cms govt logos
    handleFileChangeGovtLogo = (e, index) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 5 * 1024 * 1024) {
            alert("File size should be less than 5MB");
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            this.setState((prevState) => {
                const list = [...prevState.govtLogoList];
                list[index].formfile = reader.result; 
                list[index].filename = file.name;
                list[index].filetype = file.type;
                list[index].filepath = ""; 
                return { govtLogoList: list };
            });
        };
        reader.readAsDataURL(file);
    };

    handleLinkGovtLogoChange = (index, value) => {
        this.setState((prevState) => {
            const list = [...prevState.govtLogoList];
            list[index].Link = value;
            return { govtLogoList: list };
        });
    };

    addNewGovtLogo = () => {
        this.setState((prevState) => ({
            govtLogoList: [
                ...prevState.govtLogoList,
                {
                    GovtLogoID: null,
                    filename: "",
                    filetype: "",
                    formfile: "",
                    filepath: "",
                    Link: "",
                    isActive: false,
                    isPublish: false,
                    seqNo: prevState.govtLogoList.length + 1,
                },
            ],
        }));
    };

    handleToggleGovtLogo = (index, field) => {
        this.setState((prevState) => {
            const list = [...prevState.govtLogoList];
            list[index][field] = !list[index][field];

            const logo = list[index];
            const isInsert = logo.GovtLogoID === 0 || logo.GovtLogoID === null;

            let updateType = '';
            if (field === 'isActive') updateType = 'A';
            if (field === 'isPublish') updateType = 'P';

            if (!isInsert) {
                this.props.updateCmsGovtLogoStatus_action(
                    logo.GovtLogoID,
                    updateType,
                    logo.isActive,
                    logo.isPublish
                );
            }
            return { govtLogoList: list };
        });
    };

    deleteGovtLogo = (index) => {
        this.setState((prevState) => {
            const list = [...prevState.govtLogoList];
            const logo = list[index];
            const isInsert = logo.GovtLogoID === 0 || logo.GovtLogoID === null;

            if (!isInsert) {
                if (!window.confirm("Are you sure you want to delete this logo?")) {
                    return null; // Cancel operation if false
                }
                this.props.updateCmsGovtLogoStatus_action(
                    logo.GovtLogoID,
                    'D', 
                    logo.isActive,
                    logo.isPublish
                );
            }

            list.splice(index, 1);
            return { govtLogoList: list };
        });
    };

    handleSaveGovtLogo = () => {
        if (this.state.govtLogoList.length === 0) {
            toastError("Please add atleast one logo");
            return;
        }
        const payload = this.state.govtLogoList.map((logo) => {
            return {
                GovtLogoID: logo.GovtLogoID,
                filepath: logo.filepath ? logo.filepath : logo.GovtLogoFilepath ? logo.GovtLogoFilepath : "",
                filename: logo.filename ? logo.filename : "",
                filetype: logo.filetype ? logo.filetype : "",
                formfile: logo.formfile ? logo.formfile : "",
                Link: logo.Link,
                isActive: logo.isActive,
                isPublish: logo.isPublish,
                seqNo: logo.seqNo,
            };
        });

        this.props
            .insertUpdateCMSGovtLogo_action(payload)
            .then((res) => {
                if (res.error !== 1) {
                    toastSuccess("Logos saved successfully");
                    this.getCmsContent();
                } else {
                    toastError(res.msg);
                }
            })
            .catch((err) => {
                toastError("Error saving logos");
                console.error("Error saving logos:", err);
            });
    };

    render() {
        const { menuList, cmsMenuData, cmsFooterData, cmsSubheaderData, govtLogoList, downloadUrl } = this.state;
        return (
            <>
                <Header headerNavs={cmsMenuData} />
                <main className="main-area fix">
                    <section className="slider__area-two">
                        <div className="swiper slider-active-two">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide slider__bg-two">
                                    <div className="container">
                                        <div className="slider__content-two header_text">
                                            <section>
                                                <div className="page-header" style={{ marginTop: '80px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <h2 className="mb-1 dashboard-tit py-0 blog-name mx-4">CMS Menu Master</h2>
                                                </div>
                                                
                                                {/* IMPLEMENTED NATIVE REACT-BOOTSTRAP TABS HERE */}
                                                <div className="edit-award-rofile-body pr-1" style={{ position: 'relative', zIndex: 10 }}>
                                                    <Tabs
                                                        defaultActiveKey="Main"
                                                        id="cms-header-tabs"
                                                        className="nav nav-tabs nav-tabs-custom nav-success mb-3 myOrderTabs"
                                                    >
                                                        <Tab eventKey="Main" title="Main Menu" tabClassName="tabs-color">
                                                            <div className="pt-3">
                                                                <button className="btn rounded-1 edit-submit-btn me-2 p-1 px-2 mb-3 mt-1" onClick={() => this.submitMenu()}>Submit Menu</button>
                                                                <button className="btn rounded-1 add-sec-btn p-1 px-2 mb-3 mt-1" onClick={() => this.addNewMenu()}>Add Menu</button>
                                                                <table className="table table-bordered">
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{ width: '425px' }}>Title</th>
                                                                            <th style={{ width: '425px' }}>URL</th>
                                                                            <th className="text-center" style={{ width: '100px' }}>Sequence</th>
                                                                            <th className="text-center" style={{ width: '100px' }}>Active</th>
                                                                            <th className="text-center" style={{ width: '100px' }}>Publish</th>
                                                                            <th className="text-center" style={{ width: '100px' }}>Menu Item</th>
                                                                            <th className="text-right" style={{ width: '100px' }}>Actions</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <DragDropContext onDragEnd={this.onDragEnd}>
                                                                        <Droppable droppableId="menuList" type="PARENT">
                                                                            {(provided) => (
                                                                                <tbody ref={provided.innerRef} {...provided.droppableProps}>
                                                                                    {menuList.length > 0 ? (
                                                                                        menuList.sort((a, b) => a.Sequence - b.Sequence).map((menu, index) => (
                                                                                            <React.Fragment key={menu.id}>
                                                                                                {this.renderMenuRow(menu, index, "", 0)}
                                                                                                {this.renderDroppableChildren(menu, `${menu.Sequence}.`, 0)}
                                                                                            </React.Fragment>
                                                                                        ))
                                                                                    ) : (
                                                                                        <tr><td colSpan={7} className="text-center">No Record Found</td></tr>
                                                                                    )}
                                                                                    {provided.placeholder}
                                                                                </tbody>
                                                                            )}
                                                                        </Droppable>
                                                                    </DragDropContext>
                                                                </table>
                                                                {menuList.length > 0 ? <>
                                                                    <button className="btn rounded-1 edit-submit-btn me-2 p-1 px-2 mb-3 mt-3" onClick={() => this.submitMenu()}>Submit Menu</button>
                                                                    <button className="btn rounded-1 add-sec-btn p-1 mx-3 px-2 mb-3 mt-3" onClick={() => this.addNewMenu()}>Add Menu</button>
                                                                </> : <></>}
                                                            </div>
                                                        </Tab>
                                                        
                                                        <Tab eventKey="Sub" title="Sub Menu" tabClassName="tabs-color">
                                                            <div className="container-fluid pt-3">
                                                                <table className="table table-bordered">
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{ width: '400px' }}>Name</th>
                                                                            <th style={{ width: '300px' }}>View Type</th>
                                                                            <th className="text-center" style={{ width: '300px' }}>Social Type</th>
                                                                            <th className="text-center" style={{ width: '400px' }}>Link</th>
                                                                            <th className="text-center" style={{ width: '100px' }}>Active</th>
                                                                            <th className="text-center" style={{ width: '100px' }}>Publish</th>
                                                                            <th className="text-right" style={{ width: '120px' }}>Actions</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {cmsSubheaderData.length > 0 ? cmsSubheaderData.map((data) => (
                                                                            <tr key={data.tableId || data.SubheaderID}>
                                                                                <td>
                                                                                    {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                                        <input type="text" value={data.SubheaderName} onChange={(e) => this.handleChange(e, "SubheaderName")} />
                                                                                    ) : (
                                                                                        <span>{data.SubheaderName}</span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                                        <select onChange={(e) => this.handleChange(e, "ViewType")} value={data.ViewType}>
                                                                                            <option value={""}></option>
                                                                                            <option value={"SM"}>Social Media</option>
                                                                                            <option value={"BTN"}>Button</option>
                                                                                        </select>
                                                                                    ) : (
                                                                                        <span>{data.ViewType}</span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                                        <select disabled={data.ViewType == "BTN"} onChange={(e) => this.handleChange(e, "SocialType")} value={data.SocialType}>
                                                                                            <option value={""}></option>
                                                                                            <option value={"Email"}>Email</option>
                                                                                            <option value={"Phone"}>Phone</option>
                                                                                            <option value={"Facebook"}>Facebook</option>
                                                                                            <option value={"LinkedIn"}>LinkedIn</option>
                                                                                            <option value={"Twitter"}>Twitter</option>
                                                                                            <option value={"Instagram"}>Instagram</option>
                                                                                            <option value={"Youtube"}>Youtube</option>
                                                                                        </select>
                                                                                    ) : (
                                                                                        <span>{data.SocialType}</span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                                        <input type="text" value={data.Link} onChange={(e) => this.handleChange(e, "Link")} />
                                                                                    ) : (
                                                                                        <span>{data.Link}</span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                                        <div class="custom-control custom-checkbox"
                                                                                            onClick={(e) => this.handleChange(e, "isActive", !data.isActive)} >
                                                                                            <input type="checkbox" class="custom-control-input" checked={data.isActive} value={data.isActive} readOnly/>
                                                                                            <label class="custom-control-label" ></label>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <span>{data.isActive == true ? "Active" : "InActive"}</span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                                        <div class="custom-control custom-checkbox"
                                                                                            onClick={(e) => this.handleChange(e, "isPublish", !data.isPublish)} >
                                                                                            <input type="checkbox" class="custom-control-input" checked={data.isPublish} value={data.isPublish} readOnly/>
                                                                                            <label class="custom-control-label" ></label>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <span>{data.isPublish == true ? 'Published' : "Unpublished"}</span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    <div className="row">
                                                                                        <div className="col-3"><i className="far fa-edit" onClick={() => this.handleEdit(data.tableId || data.SubheaderID)} /></div>
                                                                                        <div className="col-3"><i className="far fa-plus-square" onClick={() => this.handleAddRow(data.tableId || data.SubheaderID)}></i></div>
                                                                                        <div className="col-3"><i className="far fa-save" onClick={() => this.submitSubmenu()} /></div>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )) : (
                                                                            <tr><td colSpan={8}>No Record Found</td></tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </Tab>
                                                        
                                                        <Tab eventKey="govtLogo" title="Header Logos" tabClassName="tabs-color">
                                                            <div className="container-fluid pt-3">
                                                                <div className="row g-3">
                                                                    <div className="col-12 text-center mt-2 d-flex align-items-center justify-content-center gap-2 mb-2">
                                                                        <button
                                                                            className="btn btn-primary me-2"
                                                                            onClick={this.addNewGovtLogo}
                                                                        >
                                                                            <i className="bi bi-plus-circle"></i> Add New Logo
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-success me-2"
                                                                            onClick={this.handleSaveGovtLogo}
                                                                        >
                                                                            <i className="bi bi-check-circle"></i> Submit
                                                                        </button>
                                                                    </div>

                                                                    {govtLogoList.map((item, index) => (
                                                                        <div className="col-md-4 mb-2" key={index}>
                                                                            <div className="card shadow-sm">
                                                                                <div className="card-body">
                                                                                    {/* File Upload + Preview */}
                                                                                    <div className="mb-3 text-center">
                                                                                        <input
                                                                                            type="file"
                                                                                            className="form-control mb-2"
                                                                                            accept="image/*"
                                                                                            onChange={(e) => this.handleFileChangeGovtLogo(e, index)}
                                                                                        />
                                                                                        <img
                                                                                            src={
                                                                                                item.formfile
                                                                                                    ? item.formfile
                                                                                                    : (
                                                                                                        downloadUrl + '/' +
                                                                                                        (item.GovtLogoFilepath
                                                                                                            ? item.GovtLogoFilepath.replace(/\\/g, "/")
                                                                                                            : "https://via.placeholder.com/150x80?text=Logo")
                                                                                                    ) || "https://via.placeholder.com/150x80?text=Logo"
                                                                                            }
                                                                                            alt="logo"
                                                                                            className="img-fluid rounded"
                                                                                            style={{ maxHeight: "80px" }}
                                                                                        />
                                                                                    </div>

                                                                                    {/* URL */}
                                                                                    <div className="mb-3">
                                                                                        <label className="form-label">URL</label>
                                                                                        <input
                                                                                            type="url"
                                                                                            className="form-control"
                                                                                            placeholder="https://example.com"
                                                                                            value={item.Link}
                                                                                            onChange={(e) =>
                                                                                                this.handleLinkGovtLogoChange(index, e.target.value)
                                                                                            }
                                                                                        />
                                                                                    </div>

                                                                                    {/* Toggles + Delete */}
                                                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                                                        {/* Active */}
                                                                                        <div className="form-check form-switch me-3">
                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="checkbox"
                                                                                                checked={item.isActive}
                                                                                                onChange={() =>
                                                                                                    this.handleToggleGovtLogo(index, "isActive")
                                                                                                }
                                                                                                id={`active-${index}`}
                                                                                            />
                                                                                            <label
                                                                                                className="form-check-label text-dark"
                                                                                                htmlFor={`active-${index}`}
                                                                                            >
                                                                                                Active
                                                                                            </label>
                                                                                        </div>

                                                                                        {/* Publish */}
                                                                                        <div className="form-check form-switch me-3">
                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="checkbox"
                                                                                                checked={item.isPublish}
                                                                                                onChange={() =>
                                                                                                    this.handleToggleGovtLogo(index, "isPublish")
                                                                                                }
                                                                                                id={`publish-${index}`}
                                                                                            />
                                                                                            <label
                                                                                                className="form-check-label text-dark"
                                                                                                htmlFor={`publish-${index}`}
                                                                                            >
                                                                                                Publish
                                                                                            </label>
                                                                                        </div>

                                                                                        {/* Delete */}
                                                                                        <button
                                                                                            className="btn btn-outline-danger btn-sm"
                                                                                            onClick={() => this.deleteGovtLogo(index)}
                                                                                        >
                                                                                            <i className="bi bi-trash"></i> Delete
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </Tab>
                                                    </Tabs>
                                                </div>

                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                <Footer footerData={cmsFooterData} />

                <ToastContainer />
            </>
        );
    }
}

export default withRouter(connect(null, { 
    getCmsContent_action, 
    insertUpdateCmsMenu_action, 
    deleteCmsMenu_action, 
    insertUpdateCmsSubheader_action, 
    insertUpdateCMSGovtLogo_action, 
    updateCmsGovtLogoStatus_action 
})(cmsHeaderMaster));